<template>

    <section class="full-width no-padding-top" id="profile-update">

        <div class="container">

            <div class="row heading">

                <div class="col-12">
                    <h2>My profile</h2>
                </div>

            </div>

            <div class="row">

                <!-- <div class="col-12 col-md-6 order-2 order-md-1"> -->
                <div class="col-12">

                    <form id="profile-form" enctype="multipart/form-data">

                        <!-- <label for="new_avatar"><i class="far fa-user"></i>Replace avatar</label> -->
                        <!-- <input v-on:change="getAvatar" type="file" name="new_avatar" accept="image/png, image/jpeg"> -->

                        <div class="form-group">
                            <label for="first_name">First name</label>
                            <input v-model="profile.first_name" type="text" name="first_name" placeholder="First name">
                        </div>
                        <div class="form-group">
                            <label for="last_name">Last name</label>
                            <input v-model="profile.last_name" type="text" name="last_name" placeholder="Last name">
                        </div>
                        <div class="form-group">
                            <label for="user_email">Your email</label>
                            <input v-model="profile.user_email" type="text" name="user_email" placeholder="Email">
                        </div>
                        <div class="form-group">
                            <label for="user_password">Change your password</label>
                            <input v-model="profile.user_password" type="password" name="user_password" placeholder="Password">
                        </div>

                        <button @click.prevent="saveDetails" :disabled="thinking" class="core-btn">Save my details</button>

                    </form>

                </div>

                <!-- <div class="col-12 col-md-6 order-1 order-md-2">

                    <p><i class="far fa-user"></i>Your avatar</p>
                    <img class="avatar" v-bind:src="profile.avatar_url" alt>

                </div> -->

            </div>

        </div>

    </section>

</template>

<script>
    module.exports = {

        name: 'profile-update',

        data() {

            return {

                thinking: false,

                profile: {

                    user_id: pageData.user_profile.id,
                    first_name: pageData.user_profile.first_name,
                    last_name: pageData.user_profile.last_name,
                    user_email: pageData.user_profile.user_email,
                    avatar_url: pageData.user_profile.avatar_url,
                    new_avatar: null,
                    user_password: null,

                }

            }

        },

        methods: {

            getAvatar(e) {

                console.log(e.target.files[0]);
                this.profile.new_avatar = e.target.files[0];

            },

            saveDetails() {

                this.thinking = true;

                let formData = new FormData(document.getElementById('profile-form'));

                formData.append('action', 'lc_update_profile');

                jQuery.ajax({

                    method: 'POST',

                    url: coreVariables.ajaxUrl,

                    data: formData,

                    processData: false,
                    contentType: false,
                    dataType: 'json',
                    mimeType: 'multipart/form-data',
                    context: this,

                }).done(function(res) {

                    if (window.coreHelpers.ajaxHandleResponse(res)) {

                        this.thinking = false;

                        console.log('success', res);

                        if (res.data.avatar_url) {
                            this.profile.avatar_url = res.data.avatar_url;
                        }
                        // if(res.data.first_name){ window.vueAccount.profile.first_name = res.data.first_name;}
                        // if(res.data.last_name){ window.vueAccount.profile.last_name = res.data.last_name;}
                        // if(res.data.user_email){ window.vueAccount.profile.user_email = res.data.user_email;}

                        coreVariables.triggerModal('Success', 'Profile saved');

                    } else {

                        this.thinking = false;
                        console.log('fail', res);
                        coreVariables.triggerModal('Slight issue', res.data.message);

                    }

                }).fail(function(req, status, error) {

                    this.thinking = false;
                    console.log('fail', req, status, error);
                    coreVariables.triggerModal('Slight issue', res.data.message);

                });
            },
        }
    }
</script>